import React, { useMemo } from 'react';
import { Form } from 'react-final-form';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';

import { generationFormValidation } from './validation';
import GenerationFormInner from './GenerationFormInner';
import validate from '../../../../../../utils/validate';
import { ASSISTANTS_CATEGORY } from '../../../../../../constants';
import { useProject } from '../../../../../../context/ProjectContext';

import scss from './GenerationForm.module.scss';

function GenerationForm() {
  const { id } = useParams();
  const { actions } = useProject();

  const generationForm = useSelector((state) => state.activ8Messages.generationForm);

  const initialGenerationFormValuesValues = useMemo(
    () => ({
      byPass: generationForm.byPass || emptyGenerationFormValues.byPass,
      focusOn: generationForm.focusOn || emptyGenerationFormValues.focusOn,
      url: generationForm.url || emptyGenerationFormValues.url,
      docs: null,
      fileText: generationForm.fileText || '',
    }),
    [generationForm],
  );

  const handleSubmitGenerationForm = (values, form) => {
    const { dirty } = form.getState();
    if (!dirty) {
      return;
    }

    actions('generateMessages', { projectId: id, values });
  };

  return (
    <div className={scss.wrapper}>
      <Form
        initialValues={initialGenerationFormValuesValues}
        onSubmit={handleSubmitGenerationForm}
        subscription={{ submitting: true, pristine: true }}
        keepDirtyOnReinitialize
        validate={(values) => validate(values, generationFormValidation())}
        render={({ handleSubmit }) => <GenerationFormInner onSubmit={handleSubmit} />}
      />
    </div>
  );
}

export default GenerationForm;

export const emptyGenerationFormValues = {
  byPass: '',
  focusOn: '',
  url: '',
  docs: null,
  fileText: '',
};

export const ACTIV8_ASSISTANT_CATEGORY = ASSISTANTS_CATEGORY.GENERATE_ALL;
